import { isPublicWebAppBuild } from 'src/app/@shared/is-public-web-app';
import { transformToUpperSnakeCase } from 'src/app/@shared/utils/to-upper-snake-case';

const INTERNAL_SUB_TYPE_OPTIONS_KEY = 'FORM.INPUT.SUB_TYPE.OPTIONS';
const PUBLIC_SUB_TYPE_OPTIONS_KEY = 'FORM.INPUT.PUBLIC_SUB_TYPE.OPTIONS';

export const getOrganizationSubTypeOptionTranslationKey = (
  subType: string,
  isPublicWebApp: boolean = isPublicWebAppBuild(),
): string => {
  const optionsKey = isPublicWebApp
    ? PUBLIC_SUB_TYPE_OPTIONS_KEY
    : INTERNAL_SUB_TYPE_OPTIONS_KEY;

  return `${optionsKey}.${transformToUpperSnakeCase(subType)}`;
};
